export default __webpack_public_path__ + "static/media/errorBg.cdabc4cf.png";